import { useCallback } from 'react';

import { getPagePath } from '@spotahome/soyuz/client';

import { navigateToOtherWindow } from '../utils/windowHelper';

import { trackModeSwitch } from './agenticTracking';

// Flips the user from classic search to the agentic surface — the mirror of
// `useSwitchToClassic`. `from` feeds the agentic page's entry_point via
// `?from=…`; AgentSeedFromUrl strips it on arrival. Defaults to `switcher`
// (the desktop filters-bar toggle); the mobile entry FAB passes
// `switcher_mobile` so the two surfaces are distinguishable in analytics.
export const useSwitchToAgentic = (from = 'switcher') =>
  useCallback(() => {
    trackModeSwitch({ context: 'classic' });
    navigateToOtherWindow(`${getPagePath('SearchAgentic')}?from=${from}`);
  }, [from]);

export default useSwitchToAgentic;
